<template>
  <section class="get-in-touch" :style="{ background: backgroundColor }">
    <h2>{{ getInTouchText }}</h2>
    <p class="subText">{{ subText }}</p>
    <button class="schedule-button" @click="redirectToCalendly">
      {{ buttonText }}
    </button>
    <p>{{ dynamicText }}</p>
    <!-- Dynamic paragraph text -->
  </section>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

// Define props with default background color
const props = defineProps({
  getInTouchText: {
    type: String,
    default: 'Get in touch with us!',
  },
  dynamicText: {
    type: String,
    required: false,
  },
  subText: {
    type: String,
    required: false,
  },
  buttonText: {
    type: String,
    default: 'Schedule now',
  },
  backgroundColor: {
    type: String,
    default: '#ffffff', // Default white background
  },
});

// Redirect to Calendly
const redirectToCalendly = () => {
  window.open(
    process.env.VUE_APP_CALENDLY_LINK, // Use the env variable here
    '_blank'
  );
};
</script>

<style scoped>
.get-in-touch {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  padding: 4rem 0;
}

.get-in-touch h2 {
  font-size: 28px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
}

.subText {
  margin-bottom: 2rem;
}
.schedule-button {
  background-color: #007ab2; /* Navy blue color */
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 10px;
  transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;
}

.schedule-button:hover {
  background-color: #00aeff; /* Slightly darker navy blue */
  transform: scale(1.05);
}

.get-in-touch p {
  font-size: 16px;
  color: #003d64;
  margin: 0;
}
</style>
